<template>
  <b-row>
  
    <b-col cols="12" class="mt-1">
      <div class="d-flex justify-content-end">
        <b-button variant="primary" v-b-modal.modal-addcategory class="my-1">
          Add Category
        </b-button>
      </div>
    </b-col>
    <b-col  cols="12" md="2" sm="2" class="my-1">
      <b-form-group label="Per Page:" label-for="per-page-select" class="mb-0">
    <b-form-select 
      id="per-page-select" 
      v-model="perPage" 
      :options="pageOptions" 
      size="sm"
    />
  </b-form-group>
    </b-col>
  
    <b-col cols="12" class="d-flex justify-content-end mb-2" style="position: relative; z-index: 1;">
      <b-button variant="outline-danger" size="sm" @click="clearFilters" :disabled="!filter">
        Clear Filters
      </b-button>
    </b-col>
    <!-- Add Category Modal -->
    <b-modal id="modal-addcategory" cancel-variant="outline-secondary" centered title="Add Category" hide-footer
      @hidden="resetAddCategoryData">
      <validation-observer ref="categoryFormAdd" #default="{ errors }">
        <b-form @submit.prevent="AddCategory" ref="addCategory">
          <b-form-group>
            <label for="Name">Category Name*</label>
            <validation-provider rules="required" v-slot="{ errors }" name="Category" vid="Category">
              <b-form-input type="text" placeholder="Category Name" v-model="addCategoryData.name" />
              <small v-if="errors.length" class="text-danger">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" block @click="AddCategory">
              <b-spinner small v-if="loading" class="mx-2" />Add
            </button>
          </div>
        </b-form>
      </validation-observer>
    </b-modal>

    <!-- Edit Category Modal -->
<b-modal
  id="modal-editcategory"
  cancel-variant="outline-secondary"
  centered
  title="Edit Category"
  hide-footer
  @hidden="resetEditCategory"
>
  <validation-observer ref="categoryFormEdit" #default="{ errors }">
    <b-form @submit.prevent="saveUpdatedCategory">
      <b-form-group>
        <label for="editName">Category Name*</label>
        <validation-provider rules="required" v-slot="{ errors }" name="Category">
          <b-form-input
            id="editName"
            type="text"
            v-model="editCategoryData.name"
            placeholder="Enter Category Name"
          />
          <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
        </validation-provider>
      </b-form-group>

      <div class="modal-footer">
        <b-button variant="primary" block @click="saveUpdatedCategory">
          <b-spinner small v-if="loading" class="mx-2" /> Update
        </b-button>
      </div>
    </b-form>
  </validation-observer>
</b-modal>


    <b-col cols="12">
      <b-table striped hover responsive :per-page="perPage" :current-page="currentPage" :items="filteredCategories"
        :fields="fields" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection"
        @filtered="onFiltered">
        <template #head(name)>
          <div class="d-flex flex-column">
            <span>Category Name</span>
            <b-form-input v-model="filter" placeholder="Filter by Category Name" size="sm" @input="filterTable" />
          </div>
        </template>

        <template #cell(actions)="data">
          <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
            <template v-slot:button-content>
              <feather-icon icon="MoreVerticalIcon" size="16" class="text-body align-middle mr-25" />
            </template>
            <b-dropdown-item @click="viewCategory(data.item.id)">
              <feather-icon icon="EyeIcon" class="mr-50" />
              <span>View</span>
            </b-dropdown-item>
            <b-dropdown-item @click="updateSubcategory(data.item)">
              <feather-icon icon="EditIcon" class="mr-50" />
              <span>Edit</span>
            </b-dropdown-item>
            <b-dropdown-item @click="removeitemCategory(data.item.id)">
              <feather-icon icon="TrashIcon" class="mr-50" />
              <span>Delete</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>
      </b-table>

      <div class="d-flex justify-content-center mb-1">
        <b-alert variant="warning" show v-if="categoryList.length === 0" class="d-flex justify-content-center">
          <h4 class="alert-heading">No categories yet, please add</h4>
        </b-alert>
      </div>

      <div class="d-flex justify-content-center mb-1">
        <b-alert variant="danger" show v-if="errorCall" class="d-flex justify-content-center">
          <h4 class="alert-heading">
            An Error has occured, please try again later
          </h4>
        </b-alert>
      </div>

      <div class="d-flex justify-content-center mb-1">
        <b-spinner variant="success" label="Spinning" block v-if="loading"
          style="width: 3rem; height: 3rem"></b-spinner>
      </div>
    </b-col>

    <b-col cols="12">
      <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" align="center" size="sm"
        class="my-0" />
      <b-form-group>
        Showing 
        {{ totalRows > 0 ? (perPage * (currentPage - 1) + 1) : 0 }} 
        to 
        {{ totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0 }} 
        of 
        {{ totalRows > 0 ? totalRows : 0 }} 
        entries
      </b-form-group>
    </b-col>
  </b-row>
</template>

<script>
import {
  BTable,
  BForm,
  BBadge,
  BAlert,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BDropdown,
  BDropdownItem,
  BSpinner,
  BFormCheckbox,
} from "bootstrap-vue";
import Swal from "sweetalert2";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    BTable,
    BBadge,
    BAlert,
    BForm,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BDropdown,
    BDropdownItem,
    BSpinner,
    BFormCheckbox,
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10, 20, 50], // Options for per page dropdown
    currentPage: 1,
    totalRows: 0,
      addCategoryData: {
        name: "",
        isSub: false,
        parentId: "",
      },
      editCategoryData: {
        name: "",
        id: null,
        parentId: null,
        isSub: false,
      },
      errorCall: false,
      pageOptions: [3, 5, 10],
      totalRows: 0,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: "",
      filterOn: [],
      categoryNames: [],
      materialOptions: [
        { value: "Nylon", text: "Nylon" },
        { value: "Cotton", text: "Cotton" },
        { value: "Wool", text: "Wool" },
        { value: "Polyester", text: "Polyester" },
      ],
      fields: [
        { key: "name", label: "Category Name", sortable: true },
        { key: "actions", label: "Actions", sortable: false },
      ],
    };
  },
  computed: {
    ...mapGetters("itemcategoryModule", {
      categoryList: "itemcategories",
      loading: "loading",
    }),
    filteredCategories() {
      return this.categoryList.filter((category) => {
        return category.name.toLowerCase().includes(this.filter.toLowerCase());
      });
    },
    formattedCategoryList() {
      const categoryIdToNameMap = this.categoryList.reduce((map, category) => {
        map[category.id] = category.name;
        return map;
      }, {});

      return this.categoryList
        .filter((category) => category.parentId === null)
        .map((category) => ({
          ...category,
          parentName: categoryIdToNameMap[category.parentId] || "-",
        }));
    },
  },
  async mounted() {
    this.$swal({
      title: "Loading...",
      text: "Please wait while the details are loading...",
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        this.$swal.showLoading();
      },
    });

    await this.getItemCategoryListAction()
      .then(() => {
        this.totalRows = this.categoryList.length;
        this.$swal.close();
      })
      .catch(() => {
        this.errorCall = true;
        this.$swal.close();
      });

    this.updateCategoryNames();
  },
  methods: {
    updateSubcategory(category) {
  if (!category) return;

  // Pre-fill modal with existing category data
  this.editCategoryData = { ...category };

  // Open modal
  this.$bvModal.show("modal-editcategory");
},
async saveUpdatedCategory() {
  let isValid = await this.$refs.categoryFormEdit.validate();
  if (!isValid) return;

  let payload = {
    id: this.editCategoryData.id,
    name: this.editCategoryData.name.trim(), // Only updating name
  };

  try {
    // Await response properly to prevent unnecessary .then() chaining issues
    const response = await this.updateItemCategoryAction(payload);
    console.log("response",response)
    // Check if the response indicates success
    if (response && response.data.success) {
      this.$swal({
        title: "Success!",
        text: "Category name updated successfully.",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
      });

      // Close modal
      this.$bvModal.hide("modal-editcategory");

      // Reset form & reload category list
      this.$refs.categoryFormEdit.reset();
      await this.getItemCategoryListAction();
    } else {
      throw new Error(response.message || "Unknown error while updating category.");
    }
  } catch (error) {
    this.$swal({
      title: "Error!",
      text: error.response?.data?.message || error.message || "Failed to update category name.",
      icon: "error",
      customClass: {
        confirmButton: "btn btn-danger",
      },
    });
  }
},
resetEditCategory() {
  this.editCategoryData = {
    name: "",
    id: null,
  };
},
    filterTable() {
      this.currentPage = 1;  // Reset to first page on filter change
      this.totalRows = this.filteredCategories.length;
    },
    clearFilters() {
      // Clear the filter and reset pagination
      this.filter = "";
      this.currentPage = 1;
      this.totalRows = this.categoryList.length;
    },
    resetAddCategoryData() {
      this.addCategoryData.name = "";
      this.addCategoryData.isSub = false;
      this.addCategoryData.parentId = null;
    },
    reDo() {
      this.getItemCategoryListAction().then(() => {
        this.totalRows = this.categoryList.length;
      });
    },
    getCategoryNames() {
      return this.categoryList
        .sort((a, b) => a.name.localeCompare(b.name))
        .filter((cat) => !cat.isSub)
        .map((category) => ({
          value: category.id,
          text: category.name,
        }));
    },
    updateCategoryNames() {
      this.editCategoryData.id = null;
      this.addCategoryData.id = null;
      this.categoryNames = this.getCategoryNames();
    },
    getitemCategoryData(data) {
      this.editCategoryData = { ...data };
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    viewCategory(categoryId) {
      this.$router.push({
        name: "category-details",
        params: { id: categoryId },
      });
    },
    removeitemCategory(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeItemCategoryAction(id)
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Deleted!",
                text: "Your category has been deleted.",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              
              this.getItemCategoryListAction()
      .then(() => {
        this.totalRows = this.categoryList.length;
        this.$swal.close();
      });
            })
            .catch((error) => {
              this.$swal({
                title: "Delete failed!",
                text: error.response.data.message,
                icon: "error",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Your category is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    successAdd() {
      this.$swal({
        title: "Category Added!",
        text: "You have successfully added a Category!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
      this.getItemCategoryListAction();
      this.totalRows = this.categoryList.length;
    },
    errorAdd(error) {
      this.$swal({
        title: "Error!",
        text: error.response.data.message,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    successEdit() {
      this.$swal({
        title: "Category type edited!",
        text: "You have successfully edited a Category type!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    errorEdit(error) {
      this.$swal({
        title: "Error!",
        text: error.response.data.message,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    async EditCategory() {
      let isValid = await this.$refs.categoryFormEdit.validate();
      if (isValid) {
        let payload = {
          name: this.editCategoryData.name,
          id: this.editCategoryData.id,
          parentId: this.editCategoryData.isSub
            ? this.editCategoryData.parentId
            : null,
          isSub: this.editCategoryData.isSub,
        };
        this.updateItemCategoryAction(payload)
          .then(() => {
            this.successEdit();
            this.$bvModal.hide("modal-editcategory");
            this.getItemCategoryListAction();
            this.updateCategoryNames();
          })
          .catch((error) => {
            this.errorEdit(error);
            this.$bvModal.hide("modal-editcategory");
            this.getItemCategoryListAction();
          });
      }
    },
    async AddCategory() {
      let isValid = await this.$refs.categoryFormAdd.validate();

      if (isValid) {
        let payload = {
          name: this.addCategoryData.name,
          parentId: this.addCategoryData.isSub
            ? this.addCategoryData.parentId
            : null,
          isSub: this.addCategoryData.isSub,
        };
        this.addItemCategoryAction(payload)
          .then(() => {
            this.successAdd();
            this.$bvModal.hide("modal-addcategory");
            this.$refs.addCategory.reset();
            this.updateCategoryNames();
            
          })
          .catch((error) => {
            this.errorAdd(error);
            this.$bvModal.hide("modal-addcategory");
            this.getItemCategoryListAction();
          });
      }
    },
    ...mapActions("itemcategoryModule", [
      "getItemCategoryListAction",
      "removeItemCategoryAction",
      "addItemCategoryAction",
      "updateItemCategoryAction",
    ]),
  },
};
</script>

<style scoped>
.d-flex {
  display: flex;
}

.justify-content-center {
  justify-content: center;
}

.mb-1 {
  margin-bottom: 1rem;
}
</style>
